import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../../content/ContentContext';
import { useUi } from '../../i18n/ui';
import SocialLinks from '../SocialLinks';

const LOGO = '/img/INSOLITA_SARDEGNA_LOGO_MOTOCLUB-white.svg';

const Footer: React.FC = () => {
  const { t, img } = useContent();
  const { tr } = useUi();
  const phone = t('contact.phone', '+393467814537');
  const logo = img('brand.logo', LOGO);
  const email = t('contact.email', 'info@insolitasardegna.com');
  const address = t('contact.address', 'Via Vincenzo Piro, Olbia');
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer__grid">
          <div>
            <div className="footer__logo"><img src={logo} alt="Insolita Sardegna" /></div>
            <p className="footer__about">
              {t('footer.about', 'Siete appassionati di motori e amate l\'avventura? Sentieri "selvaggi" nel cuore verde della Sardegna vi aspettano.')}
            </p>
            <SocialLinks />
          </div>
          <div>
            <h4>{tr('footer.moto')}</h4>
            <ul className="footer__nav">
              <li><Link to="/storia">{tr('nav.storia')}</Link></li>
              <li><Link to="/iscrizioni">{tr('nav.iscrizioni')}</Link></li>
              <li><Link to="/tour">{tr('nav.tour')}</Link></li>
              <li><Link to="/contatti">{tr('nav.contatti')}</Link></li>
            </ul>
          </div>
          <div>
            <h4>{tr('footer.eventi')}</h4>
            <ul className="footer__nav">
              <li><Link to="/gare">Sardegna Rally Raid</Link></li>
              <li><Link to="/tour">Transardegna</Link></li>
              <li><Link to="/gare">{tr('footer.link.convenzioni')}</Link></li>
              <li><Link to="/gare">{tr('footer.link.sponsor')}</Link></li>
            </ul>
          </div>
          <div>
            <h4>{tr('footer.contatti')}</h4>
            <ul className="footer__nav">
              <li><a href={`https://maps.google.com/?q=${encodeURIComponent(address)}`}>{address}</a></li>
              <li><a href={`tel:${phone}`}>{phone}</a></li>
              <li><a href={`mailto:${email}`}>{email}</a></li>
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <span>© {year} Insolita Sardegna — Moto Club</span>
          <span className="footer__legal">
            <Link to="/privacy">{tr('footer.privacy')}</Link>
            <Link to="/termini">{tr('footer.termini')}</Link>
            <Link to="/admin/login">{tr('footer.login')}</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
